(function () {
  'use strict';
  angular.module('vcconsult')
    .component('consulteditor', {
      restrict: 'E',
      bindings: {
        consultid: '<',
        startcheckout: '&?',
        onfinish: '&?'
      },
      templateUrl: 'vcconsult/consulteditor-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', 'Consult', 'PatdocsHelper', 'CartHelper', 'ConsultHelper', 'Rlog', 'Patient', 'PrintHelper', 'vertxEventBusService', '$window', '$timeout',
        function ($log, Consult, PatdocsHelper, CartHelper, ConsultHelper, Rlog, Patient, PrintHelper, vertxEventBusService, $window, $timeout) {
          let vm = this;
          vm.save = save;
          vm.childsave = childsave;
          vm.oncancel = oncancel;
          vm.addReferralModal = PatdocsHelper.addReferral;
          vm.addAideModal = PatdocsHelper.addAide;
          vm.editCart = CartHelper.editCart;
          vm.closeConsultModal = ConsultHelper.closeConsultModal;
          vm.finish = finish;
          vm.consultPreviewUrl = PrintHelper.consultPreviewUrl;
          vm.togglestar = togglestar;
          // vm.addRecipientModal = addRecipientModal;

          // vm.consultid might be late propagating, get consult on first change
          vm.$onChanges = function (changes) {

            if (angular.isDefined(changes.consultid) && angular.isDefined(changes.consultid.currentValue) && changes.consultid.currentValue.length > 0) {
              vm.consultid = changes.consultid.currentValue;
              Consult.$find(vm.consultid).$then(function (consult) {
                if (angular.isUndefined(consult.recipient)) {
                  consult.recipient = 'patient';
                }
                vm.consult = consult;
                $log.debug('[CONSULT][ConsultEditor]loaded consult');
                Patient.$find(vm.consult.patientid).$then(function (pat) {
                  $log.debug('[CONSULT][ConsultEditor]loaded patient');
                  vm.patient = pat;
                });
              }, function (err) {
                $log.error('[CONSULT][ConsultEditor]consult not found, id: ', vm.consultid, err);
                Rlog.error('consult', 'consulteditor', 'consult not found', {_id: vm.consultid});
              });
            }
          };


          function togglestar() {
            if (angular.isUndefined(vm.consult.stared)) {
              vm.consult.stared = false;
            }
            vm.consult.stared = !vm.consult.stared;
            vm.save();
          }

          function finish(docs, invdocs) {
            $log.debug('[CONSULT][ConsultEditor] consulteditor finish with: ', docs, invdocs);

            vm.consult.docs = docs;
            vm.consult.invdocs = invdocs;
            vm.consult.open = false;


            $log.debug(' ### consulteditor finish, now closing all consult exams');
            try {
              vm.consult.examinations.forEach((exam) => {
                exam.open = false;
                exam.$save();
              });
            } catch
              (err) {
              $log.error('[CONSULT][ConsultEditor] Failed to close exam for consultid: ', vm.consultid, err);
            }

            $log.debug('[CONSULT][ConsultEditor] finish, now saving closed consult');
            if (vm.consult.$hasPendingActions) {
              $log.warn('[CONSULT][ConsultEditor] consult save had pending actions, cancelling now.');
              vm.consult.$cancel();
              $timeout(function () {
                $log.warn('[CONSULT][ConsultEditor]  waited 1.5 seconds because of consult having had pending actions, saving now.');
                finishsave();
              }, 1500);
            } else {
              finishsave();
            }

          }


          function finishsave() {
            vm.consult.$save().$then(function () {
              vm.saved = true;
              let message = vm.consult._id + ':' + $window.sessionStorage.getItem('sprtabid');
              $log.debug('[CONSULT][ConsultEditor]  saving close of consult succeeded, now sending close message: ', message);
              vertxEventBusService.publish('consults.close', {data: message});
              // tell parent to switch view directly
              vm.onfinish({consultid: vm.consult._id});
            }, function (err) {
              vm.saved = false;
              $log.error('[CONSULT][ConsultEditor]  saving of consult failed: ', err);
              Rlog.error('vcutils.consult', 'consulteditor', 'Saving of consult failed: ', {
                consultid: vm.consult._id
              });
            });
          }

          function childsave(key, value) {
            vm.consult[key] = value;
            vm.save();
          }


          function save() {
            $log.debug('[CONSULT][ConsultEditor] consult save() called');
            if (vm.consult.$hasPendingActions) {
              $log.warn('[CONSULT][ConsultEditor] consult save had pending actions, cancelling now.');
              vm.consult.$cancel();
              $timeout(function () {
                $log.warn('[CONSULT][ConsultEditor]  waited 1.5 seconds because of consult having had pending actions, saving now.');
                savesave();
              }, 1500);
            }  else {
              savesave();
            }
          }


          function savesave() {
            vm.consult.$save().$then(function () {
              $log.debug('[CONSULT][ConsultEditor]  saving of consult succeeded: ');
              vm.saved = true;
            }, function (err) {
              vm.saved = false;
              $log.error('[CONSULT][ConsultEditor] saving of consult failed: ', err);
              Rlog.error('vcutils.consult', 'consulteditor', 'Saving of consult failed: ', {
                consultid: vm.consult._id
              });
            });
          }

          function oncancel() {
            vm.canceled = true;
          }

          vm.sprsymptoms = `
          Geben Sie hier Symptome byw. Kurzanamnese ein. Um detaillierte Krankheitsgeschichten zu erfassen, 
          empfehlen wir den Einsatz von Statusbefund- bzw. Untersuchungsvorlagen. Lesen Sie die PDF Anleitung zu
          Untersuchungsvorlagen und sehen Sie sich das Einführungsvideo an.
          `;

          vm.sprfindings = `
          Geben Sie hier nur weitere, globale Befunde & Erhebungen ein.
          Die (Befund-) Zusammenfassungen der einzelnen Untersuchungen werden automatisch in den Gesamtbefund übernommen. 
          Sie können sich die Zusammenfassungen der einzelnen Untersuchungen mit dem Knopf Listenansicht (rechts) 
          ins Gedächnis rufen. Anmerkungen aus den einzelnen Untersuchungen können Sie ebenfalls rechts mit dem Knopf 
          &quot;Warnung&quot; gesammelt einsehen. Anmerkungen werden NICHT automatisch übernommen.
          `;

          vm.sprtherapy = `
          Geben Sie hier nur weitere, globale weitere Therapievorschläge ein.
          Die Therapievorschläge der einzelnen Untersuchungen werden automatisch in den Gesamtbefund übernommen. 
          Sie können sich die Therapievorschläge der einzelnen Untersuchungen mit dem Knopf Listenansicht (rechts) 
          ins Gedächnis rufen.
          `;

          vm.sprnotes = `
          Diese Patientennotizen werden nicht in Befunde oder andere Dokumente übernommen. 
          Notieren Sie sich Verwandschaftsverhältnisse, die Namen der Kinder, oder den Umstand, 
          dass Ihr Patient ein ausgemachter Hypochonder ist.
          `;


          const consultsUpdateHandler = function (message) {
            $log.debug('debug: Consults update received: ', message);
            let messages = message.split(':');
            if (angular.isDefined(vm.client) && angular.isDefined(vm.client._id)) {
              if (messages[1] !== $window.sessionStorage.getItem('sprtabid') && vm.consult._id === messages[0]) {
                vm.consult.$refresh().$then(function () {
                  $log.debug('debug: consulteditor refreshed consult: ');
                }, function (error) {
                  $log.debug('debug: consulteditor could not refresh consult: ', error);
                });
              }
            }
          };

          // only react to consult updates from other tabs/browsers
          vertxEventBusService.on('consults.update', {}, consultsUpdateHandler);

          vm.$onDestroy = function () {
            $log.debug('[CONSULT][ConsultEditor] onDestroy called');
            vertxEventBusService.unregisterHandler('consults.update', {}, consultsUpdateHandler);
          };

        }] // controller
    }); // component

// klammerfriedhof
}());
